import {createAsyncThunk} from "@reduxjs/toolkit";
import {useHttp} from "../../hooks/http.hook";
import {pageMetaTag, pageMetaTags, pageTags} from "../../utils/updateTags";
import {pagePixels} from "../../utils/updatePixel";
import Cookies from "js-cookie";

export const fetchDynamicPageInfo = createAsyncThunk(
    `dynamicPageInfo/fetchDynamicPageInfo`,
    async (params) => {
        const { request } = useHttp();

        const dataLang = localStorage.getItem('dataLang');
        const shortNameParam = dataLang ? `?lang=${JSON.parse(dataLang).shortName}` : '';

        const originalQuery = Cookies.get('x-original-query');
        const referrer = Cookies.get('x-original-referrer');

        const headers = {
            ...(originalQuery && { 'X-Original-Query': originalQuery }),
            ...(referrer && { 'X-Original-Referrer': referrer })
        };

        const { json } = await request(
            `api/getPage/${window.env.PROJECT_ID}/${params.page}${shortNameParam}`,
            'GET',
            null,
            null,
            true,
            headers
        );

        pageMetaTag(json.data);
        pageTags(json.data);
        pagePixels(json.data);
        pageMetaTags(json.data);
        return json;
    }
);

export const extraReducers = (builder) => {
    builder
        .addCase(fetchDynamicPageInfo.pending, state => {
            state.loadingStatus = 'loading'
        })

        .addCase(fetchDynamicPageInfo.fulfilled, (state, action) => {
            state.loadingStatus = 'loaded';
            state.items = action.payload.data;
            Cookies.remove('x-original-referrer');
        })

        .addCase(fetchDynamicPageInfo.rejected, state => {
            state.loadingStatus = 'error';
        })
        .addDefaultCase(() => {
        })
}